import { RecordActionContext } from "modules/record/record-producer/types/record-producer-actions";
import { executeClientAction } from "modules/record/shared/services/clientActionRuntime";

const executeActionScript = async (
    script: string,
    context: RecordActionContext,
    record: any,
    tableName: string,
    mode: "form" | "related_form" = "form",
    timeoutMs?: number | string | null
) => {
    try {
        return await executeClientAction({
            script,
            mode,
            baseContext: context,
            current: record,
            tableName,
            timeoutMs,
        });
    } catch (error) {
        context.alert(
            'SCRIPT_RUNTIME_ERROR',
            (error as Error).message
        );
        console.error(
            'Action Script Runtime Error:',
            error
        );
        throw error;
    }
};

export { executeActionScript };
